export default "__VITE_ASSET__C8i1mIXZ__"